import { ModuleWithProviders, NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core'
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators'
import { UnsavedChangesService } from '@app/shared/services/unsaved-changes.service'
import { PropertyService } from '@app/shared/services/property.service'
import { LocalizationService } from '@app/shared/services/localization.service'
import { ResultGroupComponent } from '@app/shared/components/result-group/result-group.component'
import { AppMaterialModule } from '../app-material.module'
import { FocusDirective } from './directives/focus.directive'
import { FormControlComponent } from './components/form-control/form-control.component'
import { DeleteButtonComponent } from './components/delete-button/delete-button.component'
import { DeleteDialogComponent } from './dialogs/delete-dialog/delete-dialog.component'
import { TextPropertyComponent } from './components/entity/text-property/text-property.component'
import { NumberPropertyComponent } from './components/entity/number-property/number-property.component'
import { BooleanPropertyComponent } from './components/entity/boolean-property/boolean-property.component'
import { ListPropertyComponent } from './components/entity/list-property/list-property.component'
import { EntityEditorComponent } from './components/entity/entity-editor/entity-editor.component'
import { PropertyGroupComponent } from './components/entity/property-group/property-group.component'
import { CallbackPipe } from './pipes/callback/callback.pipe'
import { EntityUpdateService } from './services/entity-update.service'
import { EntityService } from './services/entity.service'
import { ActionToolbarComponent } from './components/action-toolbar/action-toolbar.component'
import { ConfirmDialogComponent } from './dialogs/confirm-dialog/confirm-dialog.component'
import { ConfirmService } from './services/confirm.service'
import { DeleteService } from './services/delete.service'
import { SharedAhuService } from './services/ahu/shared-ahu.service'
import { BorderComponent } from './components/border/border.component'
import { PrintDialogComponent } from './dialogs/print-dialog/print-dialog.component'
import { PrintService } from './services/print/print.service'
import { CalculatedIconComponent } from './components/calculated-icon/calculated-icon.component'
import { SpinnerComponent } from './components/spinner/spinner.component'
import { LocalizeNumberPipe } from './pipes/localize-number/localize-number.pipe'
import { LocalizeNumberPropertyPipe } from './pipes/localize-number-property/localize-number-property.pipe'
import { GroupEditTableComponent } from './components/group-edit-table/group-edit-table.component'

@NgModule({
  declarations: [
    FocusDirective,
    FormControlComponent,
    DeleteButtonComponent,
    DeleteDialogComponent,
    TextPropertyComponent,
    NumberPropertyComponent,
    BooleanPropertyComponent,
    ListPropertyComponent,
    EntityEditorComponent,
    PropertyGroupComponent,
    CallbackPipe,
    ActionToolbarComponent,
    ConfirmDialogComponent,
    BorderComponent,
    PrintDialogComponent,
    CalculatedIconComponent,
    SpinnerComponent,
    LocalizeNumberPipe,
    LocalizeNumberPropertyPipe,
    ResultGroupComponent,
    GroupEditTableComponent,
  ],
  imports: [CommonModule, TranslateDirective, TranslatePipe, AppMaterialModule, ReactiveFormsModule],
  exports: [
    AppMaterialModule,
    ReactiveFormsModule,
    TranslateDirective,
    TranslatePipe,
    FocusDirective,
    RxReactiveFormsModule,
    FormControlComponent,
    DeleteButtonComponent,
    EntityEditorComponent,
    CallbackPipe,
    ActionToolbarComponent,
    BorderComponent,
    CalculatedIconComponent,
    SpinnerComponent,
    LocalizeNumberPipe,
    LocalizeNumberPropertyPipe,
    ResultGroupComponent,
    BooleanPropertyComponent,
    GroupEditTableComponent,
    ListPropertyComponent,
    NumberPropertyComponent,
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        EntityUpdateService,
        EntityService,
        ConfirmService,
        DeleteService,
        SharedAhuService,
        PrintService,
        PropertyService,
        UnsavedChangesService,
        LocalizationService,
        LocalizeNumberPipe,
        LocalizeNumberPropertyPipe,
      ],
    }
  }
}
